import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  templateUrl: './find-pw.html',
  styleUrls: ['./find-pw.scss'],
})

export class FindPwPage {
  /**
   * @constructor
   */
  constructor(private $router: Router) {}

  /**
   * 로그인페이지로 이동
   */
  moveLoginPage() {
    this.$router.navigate(['']);
  }
}
